<template>
    <Card :title="$t('labels.exit_declaration_status')">
        <div class="card-body">
            <ExitDeclarationStatusFieldsetGroup v-if="exitDeclarationStatus" :exit-declaration-status="exitDeclarationStatus" />
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton size="sm" color="light" @click="remove" class="mr-2">
                <span>{{ $t('buttons.delete') }}</span>
            </AppButton>
            <AppButton size="sm" color="teal" @click="update">
                <span>{{ $t('buttons.edit') }}</span>
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from '../../../../components/new/CardComponent.vue';
import AppButton from '../../../../components/new/button/AppButton.vue';
import ExitDeclarationStatusFieldsetGroup from './fieldsets/ExitDeclarationStatusFieldsetGroup.vue';
import { httpClient } from '../../../../services/HttpClient';
import MessageNotificator from '../../../../services/MessageNotificator.js';
export default {
    name: "EditExitDeclarationStatusPage",
    components: {
        Card, AppButton, ExitDeclarationStatusFieldsetGroup
    },
    data() {
        return {
            exitDeclarationStatus: null
        }
    },
    methods: {
        async fetchExitDeclarationStatus() {
            await httpClient.get(`/management/exit-declaration-statuses/${this.$route.params.exitDeclarationStatusUuid}`).then((response) => {
                this.exitDeclarationStatus = response.data.data
            });
        },
        async update() {
            await httpClient.put(`/management/exit-declaration-statuses/${this.exitDeclarationStatus.uuid}`, {
                name: this.exitDeclarationStatus.name,
                color: this.exitDeclarationStatus.color,
                type: this.exitDeclarationStatus.type,
                order: this.exitDeclarationStatus.order
            }).then((response) => {
                this.exitDeclarationStatus = response.data.data
                new MessageNotificator().success(this.$t('alerts.success'));
            });
        },
        remove() {
            new MessageNotificator().confirm(this.$t('alerts.delete_exit_declaration_status'), async () => {
                await httpClient.delete(`/management/exit-declaration-statuses/${this.exitDeclarationStatus.uuid}`).then(() => {
                    this.$router.push({ name: 'IndexExitDeclarationStatusPage' });
                });
            });
        }
    },
    mounted() {
        this.fetchExitDeclarationStatus();
    }
}
</script>
